import { ThemeName } from '../schemas';
import { setUserThemeName, userThemeNameSelector } from '../slice';

import { useAppDispatch, useAppSelector } from '@/app/hooks';

const useThemeName = () => {
  const dispatch = useAppDispatch();
  const themeName = useAppSelector(userThemeNameSelector);

  const updateThemeName = (newThemeName: ThemeName) => {
    dispatch(setUserThemeName(newThemeName));
  };

  return { themeName, updateThemeName };
};

export default useThemeName;
